import React from 'react';
import { Group, Text } from '@mantine/core';

/**
 * "AI is thinking" loader — the neural_loader.gif (served from /public). Swaps in for a
 * plain <Loader/> wherever an LLM call is in flight (cockpit advisor headline, re-enrichment).
 */
export default function NeuralLoader({ size = 28, label }) {
  return (
    <Group gap="xs" wrap="nowrap">
      <img src="/neural_loader.gif" alt="thinking" width={size} height={size} style={{ display: 'block' }} />
      {label && <Text size="sm" c="dimmed">{label}</Text>}
    </Group>
  );
}
